// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Tooltip = require("../../../reason/common/Tooltip.bs.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var SystemMessages = require("../../../reason/systemMessages/SystemMessages.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var FragmentErrorBoundary = require("../../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var UnselectedUnionMemberError = require("../../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
var ToggleMatchDismissButtonMutation_graphql = require("../../../__generated__/ToggleMatchDismissButtonMutation_graphql.bs.js");
var ToggleMatchDismissButton_matchV5_graphql = require("../../../__generated__/ToggleMatchDismissButton_matchV5_graphql.bs.js");
var ToggleMatchDismissButton_UndismissMatchMutation_graphql = require("../../../__generated__/ToggleMatchDismissButton_UndismissMatchMutation_graphql.bs.js");

var context = React.createContext(undefined);

var make = context.Provider;

function use() {
  return React.useContext(context);
}

var ConnectionContext = {
  context: context,
  make: make,
  use: use
};

var convertFragment = ToggleMatchDismissButton_matchV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ToggleMatchDismissButton_matchV5_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ToggleMatchDismissButton_matchV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ToggleMatchDismissButton_matchV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ToggleMatchDismissButton_matchV5_graphql.node, convertFragment, fRef);
}

var Fragment_matchStatusChangeForbiddenReson_decode = ToggleMatchDismissButton_matchV5_graphql.Utils.matchStatusChangeForbiddenReson_decode;

var Fragment_matchStatusChangeForbiddenReson_fromString = ToggleMatchDismissButton_matchV5_graphql.Utils.matchStatusChangeForbiddenReson_fromString;

var Fragment = {
  matchStatusChangeForbiddenReson_decode: Fragment_matchStatusChangeForbiddenReson_decode,
  matchStatusChangeForbiddenReson_fromString: Fragment_matchStatusChangeForbiddenReson_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertVariables = ToggleMatchDismissButtonMutation_graphql.Internal.convertVariables;

var convertResponse = ToggleMatchDismissButtonMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = ToggleMatchDismissButtonMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, ToggleMatchDismissButtonMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use$2 = RescriptRelay_Mutation.useMutation(convertVariables, ToggleMatchDismissButtonMutation_graphql.node, convertResponse, convertWrapRawResponse);

var Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$2
};

var convertVariables$1 = ToggleMatchDismissButton_UndismissMatchMutation_graphql.Internal.convertVariables;

var convertResponse$1 = ToggleMatchDismissButton_UndismissMatchMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$1 = ToggleMatchDismissButton_UndismissMatchMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, ToggleMatchDismissButton_UndismissMatchMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var use$3 = RescriptRelay_Mutation.useMutation(convertVariables$1, ToggleMatchDismissButton_UndismissMatchMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

var UndismissMatchMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$3
};

function disabledWrapper(label, children) {
  return JsxRuntime.jsx(Tooltip.make, {
              label: label,
              children: JsxRuntime.jsx("span", {
                    children: children
                  })
            });
}

function ToggleMatchDismissButton$WithoutErrorBoundary(props) {
  var __onClick = props.onClick;
  var onClick = __onClick !== undefined ? __onClick : (function (prim) {
        
      });
  var match = use$1(props.match);
  var statusChangePolicy = match.statusChangePolicy;
  var id = match.id;
  var dismissed = match.dismissed;
  var __typename = match.__typename;
  var match$1 = use$2();
  var dismissMatch = match$1[0];
  var match$2 = use$3();
  var undismissMatch = match$2[0];
  var connectionContext = React.useContext(context);
  var environment = RescriptRelay.useEnvironmentFromContext();
  var removeFromConnections = Core__Array.keepSome([Core__Option.map(connectionContext, (function (c) {
                return c.currentConnectionId;
              }))]);
  var invalidateRelevantConnections = function () {
    if (connectionContext !== undefined) {
      return RescriptRelay.Environment.invalidateAllOfConnection(environment, connectionContext.connectionKey, connectionContext.parentDataId);
    }
    
  };
  var match$3 = SystemMessages.useSystemMessages();
  var addMessage = match$3.addMessage;
  var handleError = function () {
    addMessage(SystemMessages.Message.make(undefined, "error", "There was an error dismissing the match. Please try again...", 5000, undefined, undefined));
  };
  var canDismissMatch;
  switch (statusChangePolicy.__typename) {
    case "MatchStatusChangeAllowed" :
        canDismissMatch = true;
        break;
    case "MatchStatusChangeForbidden" :
    case "__unselected" :
        canDismissMatch = false;
        break;
    
  }
  var onDismissMatch = function () {
    onClick();
    if (dismissed) {
      undismissMatch({
            connections: removeFromConnections,
            matchId: id
          }, undefined, undefined, undefined, (function (param, param$1) {
              var undismissMatch = param.undismissMatch;
              if (undismissMatch !== undefined && undismissMatch.__typename === "MatchUndismissed") {
                return invalidateRelevantConnections();
              } else {
                return handleError();
              }
            }), (function (param) {
              handleError();
            }), undefined);
    } else {
      dismissMatch({
            connections: removeFromConnections,
            matchId: id
          }, undefined, undefined, undefined, (function (param, param$1) {
              var dismissMatch = param.dismissMatch;
              if (dismissMatch !== undefined && dismissMatch.__typename === "MatchDismissed") {
                return invalidateRelevantConnections();
              } else {
                return handleError();
              }
            }), (function (param) {
              handleError();
            }), undefined);
    }
  };
  var button = JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
        onClick: (function (param) {
            onDismissMatch();
          }),
        disabled: match$1[1] || match$2[1] || !canDismissMatch,
        size: "small",
        children: Caml_option.some(dismissed ? "Undismiss match" : "Dismiss match")
      });
  switch (statusChangePolicy.__typename) {
    case "MatchStatusChangeAllowed" :
        return button;
    case "MatchStatusChangeForbidden" :
        var tmp = statusChangePolicy.reason;
        if (tmp === "NOT_MATCH_OWNER") {
          var tmp$1;
          switch (__typename) {
            case "MatchForBuyerNeedV5" :
                tmp$1 = "a buyer need";
                break;
            case "MatchForRentalNeedV5" :
                tmp$1 = "a rental need";
                break;
            case "MatchForForSalePropertyV5" :
            case "MatchForRentalPropertyV5" :
                tmp$1 = "a property";
                break;
            default:
              tmp$1 = "an entity";
          }
          return disabledWrapper("You can't remove matches for " + tmp$1 + " that you didn't create", button);
        } else {
          return button;
        }
    case "__unselected" :
        return UnselectedUnionMemberError.raise("Unselected match status change policy " + statusChangePolicy._0);
    
  }
}

var WithoutErrorBoundary = {
  make: ToggleMatchDismissButton$WithoutErrorBoundary
};

function ToggleMatchDismissButton(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "match dismissal policy",
              children: JsxRuntime.jsx(ToggleMatchDismissButton$WithoutErrorBoundary, {
                    match: props.match,
                    onClick: props.onClick
                  })
            });
}

var make$1 = ToggleMatchDismissButton;

exports.ConnectionContext = ConnectionContext;
exports.Fragment = Fragment;
exports.Mutation = Mutation;
exports.UndismissMatchMutation = UndismissMatchMutation;
exports.disabledWrapper = disabledWrapper;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make$1;
/* context Not a pure module */
